import React, { FC } from "react";
import { COLUMNTITLES } from "../../utils/Enum";
import CategoryIndices from "../../interfaces/CategoryIndices";

interface IndicesProps {
  categoryTab?: string;
  title?: string;
  risksScoreIndices?: Partial<CategoryIndices>[]; //Updated to be consistent with the actual content
  key?: number;
}

const Indices: FC<IndicesProps> = ({
  categoryTab,
  title,
  risksScoreIndices,
  key,
}) => {
  const isAllorArchived =
    categoryTab === COLUMNTITLES.OVERALL ||
    categoryTab === COLUMNTITLES.ARCHIVED;
  const isRiskScroeIndices = risksScoreIndices && risksScoreIndices.length > 0;
  const renderIndices = () =>
    risksScoreIndices?.map((indices, index) => (
      <div
        key={index}
        className={`shadow-lg shadow-gray-500/50 m-4 xl:!w-[250px] xl:h-[136px] 2xl:!w-[250px] 2xl:h-[136px] shrink-0 rounded-md bg-gray-400 @max-[275px]:mb-3 sm:m-4 sm:mb-4 md:m-4 lg:m-6 xl:m-8 2xl:m-8  ${indices.checked ? "font-bold" : "font-normal"}`}
      >
        <div className="h-[32px] text-[14px] xl:h-[44px] xl:text-[16px] 2xl:h-[44px] 2xl:text-[16px] font-normal mt-[16px] mx-[16px]">
          {indices.indicesTitle}
        </div>
        <div className="text-[16px] mt-[8px] mx-[16px]">{indices.source}</div>
        <div className="flex justify-between items-center">
          <div className="text-[16px] mt-[8px] mx-[16px]">{indices.year}</div>
          <div className="m-[10px]">
            <input
              type="checkbox"
              className={`h-[20px] w-[20px]`}
              checked={indices.checked}
              readOnly
              disabled={isAllorArchived}
            />
          </div>
        </div>
      </div>
    ));

  return (
    <div id={`${title}-index-${key}`}>
      <div className="mt-[24px] ml-[50px]">
        <h1 className="text-[24px] font-medium" id={title}>
          {title}
        </h1>
      </div>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-6 2xl:ml-[30px] xl:ml-[30px] lg:ml-[20px] md:ml-[15px] sm:ml-[10px]">
        {isRiskScroeIndices ? (
          renderIndices()
        ) : (
          <p>No risk score indices available.</p>
        )}
      </div>
    </div>
  );
};

export default Indices;
